import { render, staticRenderFns } from "./None.vue?vue&type=template&id=f2831660&"
import script from "./None.vue?vue&type=script&lang=js&"
export * from "./None.vue?vue&type=script&lang=js&"
import style0 from "./None.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports